module.exports = __webpack_public_path__ + "img/pr-7.2f206314.png";